export const refactoryDadosAssociadoUpSellEntrada = (dadosPrevios, dadosUpSellTemporario, dadosCepEditadoLocalStorage) => {
    if (dadosCepEditadoLocalStorage) {
        return {
            ...dadosPrevios,
            DiaVenc: dadosUpSellTemporario.DiaVenc,
            Celular: dadosUpSellTemporario.Celular,
            Telefone: dadosUpSellTemporario.Telefone,
            AssEmail: dadosUpSellTemporario.AssEmail,
            CEPResid: dadosCepEditadoLocalStorage.CEPResid,
            UF: dadosCepEditadoLocalStorage.Uf,
            numeroResidencia: dadosUpSellTemporario.numeroResidencia,
            Cidade: dadosCepEditadoLocalStorage.Cidade,
            Bairro: dadosCepEditadoLocalStorage.Bairro || dadosUpSellTemporario.Bairro,
            Residencia: dadosCepEditadoLocalStorage.Residencia || dadosUpSellTemporario.Residencia,
            Complemento: dadosUpSellTemporario.Complemento,
            AssReferenciaEndereco: dadosUpSellTemporario.AssReferenciaEndereco,
            Obs1: dadosUpSellTemporario.Obs1
        };
    } else {
        return {
            ...dadosPrevios,
            DiaVenc: dadosUpSellTemporario.DiaVenc,
            Celular: dadosUpSellTemporario.Celular,
            Telefone: dadosUpSellTemporario.Telefone,
            AssEmail: dadosUpSellTemporario.AssEmail,
            CEPResid: dadosUpSellTemporario.CEPResid,
            numeroResidencia: dadosUpSellTemporario.numeroResidencia,
            Cidade: dadosUpSellTemporario.Cidade,
            Bairro: dadosUpSellTemporario.Bairro,
            Residencia: dadosUpSellTemporario.Residencia,
            Complemento: dadosUpSellTemporario.Complemento,
            AssReferenciaEndereco: dadosUpSellTemporario.AssReferenciaEndereco,
            Obs1: dadosUpSellTemporario.Obs1
        };
    }
};